import { LocalesStaticService, LocalVar } from '@ribajs/i18n'

/**
 * Service to get localized strings
 */
export class SbLocaleService {
  protected static _localesStaticService: LocalesStaticService

  protected static _singleton?: SbLocaleService

  protected constructor(locales: Record<string, any>) {
    // TODO: Adjust `LocalesStaticService` to load the language as a dynamic module
    SbLocaleService._localesStaticService = new LocalesStaticService(
      locales,
      'main',
      false,
      true,
      false,
    )
    SbLocaleService._singleton = this
  }

  public static init(locales: Record<string, any>) {
    this._singleton = new SbLocaleService(locales)
    return this._localesStaticService
  }

  /**
   * Get the singleton instance of SbLocaleService
   * @returns The singleton instance
   */
  public static getSingleton(): SbLocaleService {
    if (!SbLocaleService._singleton) {
      throw new Error('SbLocaleService not initialized')
    }
    return SbLocaleService._singleton
  }

  /**
   * Get the current language code
   * @returns The current language code
   */
  public getLangcode(): string {
    return SbLocaleService._localesStaticService.getLangcode() ?? 'de'
  }

  /**
   * Get a localized string
   * @param keyPath The key path to the localized string, e.g. `products.product.option_name.pack_number.10_html`
   * @param placeholders Placeholders to replace in the localized string
   * @returns The localized string
   */
  public async _(
    keyPath: string,
    placeholders: Record<string, any> = {},
  ): Promise<string> {
    const currentLang = this.getLangcode()
    const path: string[] = [currentLang, ...keyPath.split('.')]
    return SbLocaleService._localesStaticService.get(path, placeholders)
  }

  public async get(path: string[], vars: LocalVar = {}) {
    return SbLocaleService._localesStaticService.get(path, vars)
  }
}
